import { render, staticRenderFns } from "./safePictures.vue?vue&type=template&id=eb3ba53e&scoped=true&"
import script from "./safePictures.vue?vue&type=script&lang=js&"
export * from "./safePictures.vue?vue&type=script&lang=js&"
import style0 from "./safePictures.vue?vue&type=style&index=0&id=eb3ba53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3ba53e",
  null
  
)

export default component.exports